var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabledown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90908 0.856934H4.09497H0.660442C0.072714 0.856934 -0.22115 1.63753 0.195157 2.09512L3.36644 5.58089C3.87458 6.13942 4.70107 6.13942 5.20921 5.58089L6.41528 4.25522L8.38049 2.09512C8.79068 1.63753 8.49681 0.856934 7.90908 0.856934Z",
    fill: "#77868B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabledown);
export default __webpack_public_path__ + "static/media/tabledown.5982605bc2b1ba4171c581cb17440276.svg";
export { ForwardRef as ReactComponent };